import React from "react";
import { Grid } from "@mui/material";
import FormField from "./FormField";
import { BranchFormProps } from "../types/branch";
import { useBranchFields } from "./useBranchFields";

const BranchForm: React.FC<BranchFormProps> = (props) => {
  const { fields, handleChange } = useBranchFields(props);

  return (
    <Grid container spacing={0.5}>
      {fields.map((f) => (
        <Grid item xs={12} sm={f.grid ?? 12} key={f.id}>
          <FormField
            {...f}
            type={f.type as "text" | "select"} // ✅ cast to expected type
            onChange={(val) => handleChange(f.id, val)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default BranchForm;
